import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import Odometer from 'react-odometerjs';

const style = {
  position: 'absolute',
  backgroundColor: 'white',
  cursor: 'move',
};

const boxSource = {
  beginDrag(props) {
    const { id, left, top } = props;
    return { id, left, top };
  },
};

const withinRangeColors = {
  true: '#69cb45',
  false: '#ce2c22',
};

class DraggableBox extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    children: PropTypes.node,
  };

  renderBox(tagId, description, value, unit, loading, color, valueInRange) {
    return (
      <div className="infographic-box">
        <div className="left" style={{ backgroundColor: color }}>
          <div className="left-inner">
            <span className="id">{tagId}</span>
            <br />
            <span className="description">{description}</span>
          </div>
          <div className="bottom">
            <span className="value odometer">
              {loading ? (
                <i className="fa fa-fw fa-spinner fa-spin" />
              ) : value === undefined ? (
                'N/A'
              ) : (
                <Odometer value={value} duration={250} format="(d).dd" />
              )}
            </span>
            <span className="unit">{unit}</span>
          </div>
        </div>
        <div
          className="right"
          style={{ backgroundColor: withinRangeColors[valueInRange] }}
        />
      </div>
    );
  }

  render() {
    const {
      left,
      top,
      connectDragSource,
      isDragging,
      value,
      description,
      unit,
      id,
      loading,
      color,
      valueInRange,
    } = this.props;
    if (isDragging) {
      return null;
    }

    return connectDragSource(
      <div className="draggable-box clearfix" style={{ ...style, left, top }}>
        {this.renderBox(
          id,
          description,
          value,
          unit,
          loading,
          color,
          valueInRange
        )}
      </div>
    );
  }
}

export default DragSource('infographic-box', boxSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))(DraggableBox);



// WEBPACK FOOTER //
// ./src/components/Infographic/DraggableBox.js